import * as def from '@/definitions'
import { PathLayer } from './pathLayer'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Layer } from './layer';
import { ImageLayer } from './imageLayer';
import { UuidHelper } from '@/helper/uuidHelper';

export class RasterImageLayer extends ImageLayer
{
    public get layerType() : string { return "rasterImage"; }

    public clone()
    {
        var cloned = new RasterImageLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : RasterImageLayer)
    {
        super.cloneParameter(layer);
    }

    // 作成
    public static create(imageBase64 : string, x : number, y : number, width : number, height : number) : RasterImageLayer
    {
        var layer = new RasterImageLayer();
        layer.imageBase64 = imageBase64;
        layer.imageBase64Origin = imageBase64;
        layer.x = x;
        layer.y = y;
        layer.width = width;
        layer.height = height;
        layer.insertionId = UuidHelper.getUuid();
        return layer;
    }

    // 画像差し替えしたレイヤーを返す
    public static createImageReplacedLayer(srcLayer : ImageLayer, image : string, imageWhiteTransparent : string, imageWidth : number, imageHeight : number)
    {
        var layer = new RasterImageLayer();
        // 古いレイヤーのパラメータを新しいレイヤーに複製する
        srcLayer.cloneParameter(layer);
        // 画像をセット
        layer.imageBase64 = image;
        layer.imageBase64WhiteTransparent = imageWhiteTransparent;
        layer.imageBase64Origin = image;
        layer.imageBase64WhiteTransparentOrigin = imageWhiteTransparent;
        layer.imageWidth = imageWidth;
        layer.imageHeight = imageHeight;
        // 画像に合わせてサイズ調整を行う
        // 長辺に合わせる
        if(layer.width < layer.height)
        {
            layer.width = layer.height * imageWidth / imageHeight;
        }
        else
        {
            layer.height = layer.width * imageHeight / imageWidth;
        }
        return layer;
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : RasterImageLayer
    {
        var layer = new RasterImageLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        super.loadParameterFromJson(jsonData);
    }
}
